/**
 * PERSONALSKÄRMENS GRANSKARE.
 *
 * RADERNA KOMMER UR granskare/rader.ts. Filen bar tidigare en egen, komplett
 * avskrift av hela granskarlagret; se rader.ts för varför de sju kopiorna slogs
 * ihop.
 *
 * DE TVÅ EGNA GRANSKARNA NEDAN ÄR INTE RADGRANSKARE och hör därför hemma här:
 * ADD_MEMBER och SET_MEMBER_ROLE svarar med en MEDLEMSKAPSRAD ur den DELADE
 * databasen (schema/d1.sql), inte ur firmans Durable Object, och REMOVE_MEMBER
 * svarar med en ren bekräftelse. Ingen av dem går genom SYNC_PULL.
 */

import { ALL_ROLES } from '@delat/routes';
import type { MemberMutationResponse, RemoveMemberResponse } from '@delat/types';
import {
  Granskningsfel,
  accountId,
  companyId,
  enAv,
  flagga,
  millisekunder,
  nullbar,
  objekt,
  orgnummer,
} from '../granska';
import type { Granskare } from '../granska';

export {
  FORDONEN as FORDON,
  FRANVAROSLAGEN as FRANVAROSLAG,
  KALLORNA as KALLOR,
  KLIENTVYER as VYER_I_SVARET,
  KUNDSLAGEN as KUNDSLAG,
  MATERIALENHETERNA as MATERIALENHETER,
  ORDERLAGEN,
  PRISKALLORNA as PRISKALLOR,
  VECKOLAGEN,
  granskaArbetsorder as granskaOrder,
  granskaArbetsorderMontor as granskaOrderMontor,
  granskaFakturakorning,
  granskaFirmainstallningar,
  granskaFranvaro,
  granskaKund,
  granskaKundMontor,
  granskaMaterialrad,
  granskaMaterialradMontor,
  granskaMedlem,
  granskaMedlemMontor,
  granskaMilrad,
  granskaMilradMontor,
  granskaMoment,
  granskaOpresultat as granskaOperationsresultat,
  granskaOrderfoto,
  granskaOrdergast,
  granskaPrislista,
  granskaPrisrad,
  granskaSyncPull,
  granskaSyncPush,
  granskaTidrad,
  granskaTidradMontor,
  granskaUtlagg,
  granskaUtlaggMontor,
  granskaVeckolage as granskaVeckostatus,
} from './rader';

/** Svaret på ADD_MEMBER och SET_MEMBER_ROLE: medlemskapsraden ur D1. */
export const granskaMedlemskap: Granskare<MemberMutationResponse> = (v) => {
  const o = objekt(v, 'membership');
  return {
    company_id: companyId(o['company_id'], 'membership.company_id'),
    account_id: accountId(o['account_id'], 'membership.account_id'),
    role: enAv(o['role'], 'membership.role', ALL_ROLES),
    guest_org_number: nullbar(o['guest_org_number'], 'membership.guest_org_number', (x) =>
      orgnummer(x, 'membership.guest_org_number'),
    ),
    created_at: millisekunder(o['created_at'], 'membership.created_at'),
    updated_at: millisekunder(o['updated_at'], 'membership.updated_at'),
  };
};

/**
 * REMOVE_MEMBER svarar `{ removed: true }` och ingenting annat. Ett `false`
 * finns inte i kontraktet — kom det ändå har svaret fel form, och då ska det
 * falla här och inte tolkas som "det gick nog bra".
 */
export const granskaBorttagen: Granskare<RemoveMemberResponse> = (v) => {
  const o = objekt(v, 'remove_member');
  const borttagen = flagga(o['removed'], 'removed');
  if (!borttagen) {
    throw new Granskningsfel('removed', 'removed var false, vilket kontraktet inte tillåter');
  }
  return { removed: true };
};
